<template>
  <Base v-if="isOrderLoading" :base-id="'lb-order-loading'" :base-class="'modal-sm'">
    <template #body>系統作業中，請稍後</template>
  </Base>

  <Base v-else :base-id="'lb-cancel-order'" :base-class="'modal-sm'">
    <template #header>取消訂單</template>
    <template #body>
      提醒您訂單一經取消後，原訂單之優惠活動將一併取消，欲購買商品請重新訂購，其商品庫存及相關優惠將依訂購當下網頁資訊為準。
    </template>
    <template #footer>
      <button
        :disabled="lockBtn"
        type="button"
        class="btn btn-outline-secondary w-100 btn-sm"
        @click.prevent="confirmCancel"
      >
        確定
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary w-100 btn-sm"
        @click.prevent="closeModal"
      >
        取消
      </button>
    </template>
  </Base>
</template>

<script setup>
import { storeToRefs } from 'pinia';

import Base from '@global/components/common/modal/Base.vue';

import useModalStore from '@global/stores/useModalStore';
import useCancelOrder from '@global/composable/order/useCancelOrder';

const modalStore = useModalStore();
const { modalData } = storeToRefs(modalStore);
const { closeModal } = modalStore;

const { lockBtn, isOrderLoading, confirmCancel } = useCancelOrder({
  transactionId: modalData.value,
});
</script>
